export default __webpack_public_path__ + "static/media/thumbnail.13c0f8e7.webp";